import React, { useRef, useState } from 'react'
import {
  Row,
  Col,
  Form,
  Button,
  Alert,
  FormGroup,
  FormInput,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter
} from 'shards-react';
import { useAuth } from '../../contexts/AuthContext';
import { CardHeader } from 'shards-react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, Slide } from 'react-toastify';
import isUserAdmin from '../../utils/isUserAdmin'


export default function Signup() {
  const emailRef = useRef()
  const usernameRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const { signup } = useAuth()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false);
  const { currentUser } = useAuth();

  async function handleSubmit() {

    if (isUserAdmin(currentUser)) {
      try {
        setError('');
        setLoading(true);
        await signup(emailRef.current.value, passwordRef.current.value, usernameRef.current.value);
        emailRef.current.value = '';
      } catch (err) {
        console.log(err)
        setError(`Failed to create an account - ${err.message}`);
      }
      // Close Modal after finished
      toggleModal();
      setLoading(false)
    } else {
      setError('Insufficient Permissions')
    }
  }

  function toggleModal() {
    setOpen(!open);
  }

  function sanitiseInput(e) {
    e.preventDefault();

    setError('')
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError('Passwords do not match')
    }
    !error && toggleModal();
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        newestOnTop={true}
        closeOnClick
        rtl={false}
        transition={Slide}
        pauseOnHover={false}
      />
      <Modal centered open={open} toggle={toggleModal}>
        <ModalHeader>Are you sure?</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <label>Email</label>
              <p>{emailRef.current && emailRef.current.value}</p>
            </Col>
            <Col>
              <label>Username</label>
              <p>{usernameRef.current && usernameRef.current.value}</p>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => toggleModal()} theme="danger">Cancel</Button>
          <Button disabled={loading} onClick={() => handleSubmit()} theme="primary">Confirm Create User</Button>
        </ModalFooter>
      </Modal>
      <Card className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">Create new user</h6>
        </CardHeader>
        <CardBody>
          {error && <Alert theme="danger">{error}</Alert>}
          <Form onSubmit={e => sanitiseInput(e)}>
            <FormGroup id="email">
              <label>Email</label>
              <FormInput type="email" innerRef={emailRef} required />
            </FormGroup>
            <FormGroup id="name">
              <label>Company</label>
              <FormInput type="text" innerRef={usernameRef} required />
            </FormGroup>
            <FormGroup id="password">
              <label>Password</label>
              <FormInput type="password" innerRef={passwordRef} required />
            </FormGroup>

            <FormGroup id="password-confirm">
              <label>Password Confirmation</label>
              <FormInput type="password" innerRef={passwordConfirmRef} required />
            </FormGroup>
            <Button disabled={loading} className="w-100 mt-4">Create New User</Button>
          </Form>
        </CardBody>
      </Card>
    </>
  )
}
